import { useCallback, useEffect, useState } from 'react';

import debounce from 'lodash/debounce';

const debounceListener = debounce((entries: ResizeObserverEntry[], setElementWidth: (width: number) => void) => {
  for (const entry of entries) {
    const { width } = entry.contentRect;
    setElementWidth(width);
  }
}, 60);

export function useElementWidth(elementRef: React.RefObject<HTMLElement>) {
  const [elementWidth, setElementWidth] = useState(0);

  const listener = useCallback((entries: ResizeObserverEntry[]) => {
    debounceListener(entries, setElementWidth);
  }, []);

  useEffect(() => {
    if (elementRef.current) {
      const resizeObserver = new ResizeObserver(listener);

      resizeObserver.observe(elementRef.current);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [listener, elementRef]);

  return { elementWidth };
}
